import soledis from './global';



function initAnchorExtraContent() {
  if (!document.body.classList.contains('a-mobile-device')) {
    // if product page contain product accordions
    if (document.querySelector('#productAccordions') !== null) {
      let items = document.querySelectorAll('.panel-title-text');
      if (items.length > 0) {
        let hookReassurance = document.querySelector('.reassurance-hook');
        items.forEach(function (item, key) {
          let idAnchor = 'sld-anchor-'.concat(key);
          item.id = idAnchor;
          let newNode = createAnchorExtraContent(item, idAnchor);
          // add btn create in the hook element
          hookReassurance.parentNode.insertBefore(newNode, hookReassurance);
        });
        // add event scroll smooth
        sld.scrollSmooth.init();
      }
    }
  }
}

function createAnchorExtraContent(item, idAnchor) {
  // create btn anchor
  let link = document.createElement('a');
  link.textContent = item.textContent;
  link.href = '#'.concat(idAnchor);
  link.classList.add('sld-js-anchor', 'btn', 'btn-secondary');
  // add event to open product accordions
  link.addEventListener('click', function () {
    document.querySelector('#'.concat(idAnchor)).parentElement.click();
  })
  return link;
}

function cameraActive(codeReader, selectedDeviceId) {
  const camera = document.querySelector('.sld-scan-barcode-content');
  // const position = camera.getBoundingClientRect();
  // window.scrollTo(0, position.top - 100);
  // console.log(prestashop.urls.pages);
  const urlSearch = prestashop.urls.pages.search;
  let firstResult = null;
  codeReader.decodeFromVideoDevice(selectedDeviceId, 'video', (result, err) => {
    if (result) {
      let code = result.text;
      if (code.length === 13 && firstResult === null) {
        window.location.href = urlSearch.concat('?controller=search&s=').concat(code).concat('&utm_source=eanscanner&utm_medium=scanner&utm_campaign=codebarre');
        sld.loader.show({during: 20000, colorDots: '#E64C27'});
        firstResult = false;
      }
      else {
        if ($('#result').length) {
          document.getElementById('result').textContent = scanBarCode.translate.error
        }
      }
    }
    if (err && !(err instanceof ZXing.NotFoundException)) {
      if ($('#result').length) {
        document.getElementById('result').textContent = err
      }
    }
  })
  console.log(`Started continous decode from camera with id ${selectedDeviceId}`)
}

function sldStartScan() {

  let result = '';
  let code = '';

  const DEFAULT_SYMBOLOGIES = [
    ScanditSDK.Barcode.Symbology.QR,
    ScanditSDK.Barcode.Symbology.EAN8,
    ScanditSDK.Barcode.Symbology.EAN13,
    ScanditSDK.Barcode.Symbology.TWO_DIGIT_ADD_ON,
    ScanditSDK.Barcode.Symbology.FIVE_DIGIT_ADD_ON,
    ScanditSDK.Barcode.Symbology.UPCA,
    ScanditSDK.Barcode.Symbology.UPCE,
  ];

  const CONFIG = {
    sdk: {
      apiKey: sldthemeoneScanEditToken,
      engineLocation: 'https://cdn.jsdelivr.net/npm/scandit-sdk/build',
    },
    barcodePicker: {
      playSoundOnScan: false,
      vibrateOnScan: false,
      accessCamera: false,
      visible: false,
      guiStyle: 'none',
      cameraSettings: {
        resolutionPreference: ScanditSDK.CameraSettings.ResolutionPreference.FULL_HD
      }
    },
    scanSettings: {
      enabledSymbologies: DEFAULT_SYMBOLOGIES,
      codeDuplicateFilter: 5000,
      maxNumberOfCodesPerFrame: 1,
    },
    activeSymbolCountMin: 5,
    activeSymbolCountMax: 35,
  }

  const scanComponents = {
    barcodePicker: null,
    scanStartButton: document.querySelector('#sld-scan-start'),
    scanStopButton: document.querySelector('#sld-scan-stop'),
    barcodePickerContainer: document.querySelector('.sld-scandit-container'),
    regExInputs: [],
  };

  const onError = err => {
    if ($('#result').length) {
      document.getElementById('result').textContent = err;
    }
  }

  const onCameraError = err => {
    if ($('#result').length) {
      document.getElementById('result').textContent = err;
    }
  }

  const onScanError = err => {
    if ($('#result').length) {
      document.getElementById('result').textContent = err;
    }
  }

  const onPickerReady = () => {
    // scanComponents.scanStartButton.style.display='none';
    // scanComponents.scanStopButton.style.display='none';
  }

  const onScan = scanResult => {
    if (typeof scanResult !== 'undefined') {
      scanResult.barcodes.forEach(barcode => {
        code = barcode.data;
        if (code.length === 13) {
          let codeUrl = sldthemeoneUrl + '?code=' + code;

          // window.location.href = codeUrl;

          $.ajax({
            type: "POST",
            url: codeUrl,
            dataType: 'json',
            data: {
              code: code,
              ajax:1,
              action: 'searchEanCode',
            },
            success: function (obj, textstatus) {
              if( !('error' in obj) && ('success' in obj)) {
                $('#result').text('');
                window.location.href = obj.page_product;

              }
              else {
                $('#result').text(obj.msg);
                setTimeout(() => {
                  $('#result').text('');
                }, 5000);
                onScan();
              }
            }
          });

        }
      });
    }
  }

  const onCameraAccess = () => {
    scanComponents.barcodePicker.resumeScanning()
        .then(() => {
          scanComponents.barcodePicker.clearSession();
          scanComponents.barcodePicker.setVisible(true);
        })
  }

  const onStart = () => {
    // scanComponents.scanStartButton.classList.add('disabled');
    result = '';
    scanComponents.barcodePicker
        .accessCamera()
        .then(onCameraAccess)
        .catch(onCameraError);
  }

  ScanditSDK.configure(CONFIG.sdk.apiKey, { engineLocation: CONFIG.sdk.engineLocation })
      .then(() => ScanditSDK.BarcodePicker.create(scanComponents.barcodePickerContainer, CONFIG.barcodePicker))
      .then(createdPicker => {
        scanComponents.barcodePickerContainer
        const scanSettings = new ScanditSDK.ScanSettings(CONFIG.scanSettings);

        scanComponents.barcodePicker = createdPicker
        scanComponents.barcodePicker.applyScanSettings(scanSettings);

        scanComponents.barcodePicker
            .on('scan', onScan)
            .on('scanError', onScanError);

        onStart();
      })
      .catch(onError);
}

const resizeFullpage = () => {
  let containers = document.querySelectorAll('.sld-full-page');
  const windowWidth = document.body.clientWidth;
  if (containers.length > 0) {
      containers.forEach(container => {
          container.style.width = `${windowWidth}px`;
      })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initAnchorExtraContent();
  if (document.querySelector('#sldva_google_map') !== null) {
    resizeFullpage();
  }
  if (typeof(ScanditSDK) != 'undefined') {
    sldStartScan();
  }
});

window.addEventListener('resize', () => {
  if (document.querySelector('#sldva_google_map') !== null) {
    resizeFullpage();
  }
});
